export type ImagePresets = "thumbnail" | "webp";
export const getAssetUrl = (directusUrl: string, fileId: string, key?: ImagePresets): string => {
  return new URL(`assets/${fileId}${key ? `?key=${key}` : ""}`, directusUrl).toString();
};